import React, { useMemo } from "react";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import ManagerMobileNavbar from "../ManagerMobileNavbar/ManagerMobileNavbar";
import ManagerDashboardFooter from "../ManagerDashboardFooter/ManagerDashboardFooter";
import DashboardRouter from "../../routing/DashboardRouter";

const ManagerLayout = ({
  getSimplifiedMenu,
  userInfo,
  userTypeInfo,
  isMenuVisible,
  onMenuItemClick,
  onMenuButtonClick,
  routers,
}) => {
  const { subnetInfo } = useThemeContext();
  const showBusinessSquare = userTypeInfo === "Manager" && !!subnetInfo;
  const managerMenu = useMemo(() => getSimplifiedMenu(), [getSimplifiedMenu]);

  return (
    <div className="manager-dashboard-theme">
      <ManagerMobileNavbar onMenuButtonClick={onMenuButtonClick} />
      <DashboardSidebar
        menuItems={managerMenu}
        userInfo={userInfo}
        userTypeInfo={userTypeInfo}
        isMenuVisible={isMenuVisible}
        onMenuItemClick={onMenuItemClick}
        onMenuButtonClick={onMenuButtonClick}
        showBusinessSquare={showBusinessSquare}
      />
      <div className="layout-main dashboard-layout-main manager-dashboard-layout-main" id="home">
        <div className="layout-content">
          <DashboardRouter routers={routers} userTypeInfo={userTypeInfo} />
        </div>
        <ManagerDashboardFooter userTypeInfo={userTypeInfo} />
      </div>
    </div>
  );
};

export default ManagerLayout;
